export default {
  contactUsPaginated: (state) => state.contactUsPaginated,
  contactUsColumns: (state) => state.contactUsColumns,
  cotactUsConfig: (state) => state.cotactUsConfig,
  cotactUsConfigObject: (state) => state.cotactUsConfigObject,
  contactUsTypes: (state) => state.types,
  countactUsCount: (state) => state.countactUsCount,
  contactUsTypeColumn:(state)=> state.contactUsTypeColumn

};
